import { useRef, useState } from 'react';


const getInitPages = (final: number, inicio: number, filter: any) => {
  if (filter.savedValues) {
    return {
      /* 
      elemFin: filter.elemFin,
      elemFinal: filter.elemFinal,
      elemInicio: filter.elemInicio, 
      */
      elemFin: final - inicio,
      elemFinal: final - inicio,
      elemInicio: 0,
    };
  }
  return {
    /* elemFin: filter.elemFin,
    elemFinal: filter.elemFinal,
    elemInicio: filter.elemInicio, */
    elemFin: final - inicio,
      elemFinal: final - inicio,
      elemInicio: 0,
  };
};

const changeFilterOrdenName = (map: { [key: string]: string }, filter) => {
  return {
    ...filter,
    orden: map[filter.orden] || '',
  };
};

const buildTableHeader = (headers, filter) => {
  return headers.map((header) => {
    if (filter.orden === header.text) {
      return {
        ...header,
        orderBy: filter.ascDesc,
      };
    } else if (header.orderBy) {
      return {
        ...header,
        orderBy: 'asc',
      };
    }
    return header;
  });
};

export const useList = (
  initFilter: { [key: string]: any },
  initHeaders: any[],

  filterTableChange: { headerToAPIMap: any; action: any },
  filterFormChange: (filter: { [key: string]: any }) => void,
  filterFormNoChange: () => void
) => {
  const filterRef = useRef({
    ...initFilter,
  });
  const [data, setData] = useState([]);
  const [headers, setHeaders]: [any[], any] = useState(initHeaders);
  const [headerExcel, setheaderExcel]: [any[], any] = useState([]);
  const handleFilterTable = (filter) => {
    const newFilter = { ...filterRef.current, ...filter };

    setHeaders(buildTableHeader(headers, newFilter));

    const filterOrdenNameToAPI = changeFilterOrdenName(
      filterTableChange.headerToAPIMap,
      newFilter
    );

    filterRef.current = { ...filterOrdenNameToAPI };
    filterTableChange.action(filterOrdenNameToAPI);
  };

  const handleFilterChange = (filter) => {
    const filtroAnterior = { ...filterRef.current };
    const cambios = Object.keys(filter).some((key) => filtroAnterior[key] !== filter[key]);

    if (cambios) {
      // Actualiza el filtro interno
      filterRef.current = {
        ...initFilter,
        ...filter,
        ...getInitPages(
          filterRef.current.elemFin || filterRef.current.elemFinal,
          filterRef.current.elemInicio,
          filter
        ),
      };

      // Actualiza los encabezados de la tabla
      setHeaders(buildTableHeader(headers, filterRef.current));

      // Llama a la función filterFormChange con el filtro actualizado
      filterFormChange(filterRef.current);
    } else {
      filterFormNoChange();
    }
  };

  return {
    filterRef,
    data,
    setData,
    headers,
    setHeaders,
    headerExcel,
    setheaderExcel,
    handleFilterTable,
    handleFilterChange,
  };
};
